import request from './_config'
const path = `affiliate-history`

export function getAffiliateHistory() {
    return request({
        url: `${path}`,
        method: 'get'
    })
}
